/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipBackIcon24Regular = forwardRef('MediaUiASkipBackIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.076 3.914c1.165-.725 2.674.113 2.674 1.486v13.2c0 1.373-1.509 2.211-2.674 1.486l-10.608-6.6a1.73 1.73 0 0 1-.718-.879V19.5a.75.75 0 0 1-1.5 0v-15a.75.75 0 1 1 1.5 0v6.893c.127-.347.366-.66.718-.879l10.608-6.6ZM18.25 5.4a.25.25 0 0 0-.382-.212l-10.607 6.6a.25.25 0 0 0 0 .424l10.607 6.6a.25.25 0 0 0 .382-.212V5.4Z" })));
});
